import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { useIdentityContext } from 'react-netlify-identity/dist/index';

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      rest = _objectWithoutPropertiesLoose(_ref, ["component"]);

  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user;

  useEffect(function () {
    if (!user) {
      navigate('/signIn');
    }
  }, [user]);
  return user ? /*#__PURE__*/React.createElement(Component, rest) : null;
};

PrivateRoute.defaultProps = {
  component: undefined
};
export default PrivateRoute;